<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="dynamic-inputs">
      <div class="value-list" ref="scrollable">
        <div 
          class="value-group group-w-button"
          v-for="(val, index) in newValues" 
          :key="index"
        >
          <h5>{{ getChars(index) }}</h5>
          <input autocomplete="off" type="text" :name="`newValues[${index}][inspectionName]`" v-model="val.inspectionName" placeholder="Nominal value" @input="updateValues(index)"/>
          <input autocomplete="off" type="text" :name="`newValues[${index}][inspectionType]`" v-model="val.inspectionType" placeholder="Tolerance" @input="updateValues(index)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";
  import InputDash from "@/components/base/InputDash";
  import VerticalStepBullets from "@/components/base/VerticalStepBullets";
  import AutocompleteList from "@/components/base/AutocompleteList";
  import draggable from 'vuedraggable'

  export default {
    components: {
      BaseIcon, 
      InputDash,
      draggable,
      VerticalStepBullets,
      AutocompleteList
    },
    props: {
      label: String,
      name: String,
      neededValues: Number,
      values: Array,
      validation: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        stepsResult:[],
        newValues: [],
        isValid: Boolean,
        errorDescription: 'Inspections are not valid',
      }
    }, 
    mounted() {
      if(this.values.length != 0 && this.values[0].inspectionName != undefined) {
        this.newValues = this.values
      } else {
        this.setStartValues()
      }
    },
    methods: {
      setStartValues() {
        for (var i = 0; i < this.neededValues; i++) {
          this.newValues.push({letter: this.getChars(i), inspectionName: '', inspectionType: '', isIPC: this.values[i].isIPC})
        }
        // if(this.values == [] || this.values == undefined || this.values == null) {

        // } else {
        //   this.newValues = this.values
        // }
      },
      getChars(index) {
        let alphabet = "abcdefghijklmnopqrstuvwxyz"
        let chars = ''

        if(index > 26) {
          let amountChar = Math.floor(index / 26)
          let firstChar = alphabet[amountChar];
          let secondChar = alphabet[index - (amountChar * 26)];

          chars = firstChar + secondChar
        } else {
          chars = alphabet[index];
        }

        return chars
      },
      scrollToEnd() {
        var container = this.$refs.scrollable
        container.scrollTop = container.scrollHeight + 84;
      },
      updateValues(index) {
        var customValues = []
        for (var i = 0; i < this.newValues.length; i++) {
          let letter = this.getChars(i)
          customValues.push({letter: letter, inspectionName: this.newValues[i].inspectionName, inspectionType: this.newValues[i].inspectionType, isIPC: this.newValues[i].isIPC})
        }

        this.$emit('updateValues', customValues)
        this.scrollToEnd()
      },
      removeValue(index) {
        if (this.newValues.length > 1) {
          this.newValues.splice(index, 1);
        }
      },
      sumbitForm() {
        const data = {
          newValues: this.newValues
        }
        alert(JSON.stringify(data, null, 2))
      }
    },
    watch: {
      neededValues: function (val) {
        this.setStartValues()
      },
      values: function (val) {
        if(this.values.length != 0) {
          this.newValues = this.values
        } else {
          this.setStartValues()
        }
      },
      validation: function(newVal, oldVal) {
        this.isValid = newVal
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/inputs";
@import "@/style/components/dynamicStepsList";

::placeholder{
  color: #EFEFEF;
}

.sub-title {
  display: block;
  font-weight: 600;
  color: #035362;
  margin-bottom: 6px;
}

.dynamic-inputs {
  height: auto;
  max-height: 120px;
}

input {
  margin-left: 5% !important;
}
h5 {
  width: 24px;
  font-weight: 500;
}
.error {
  color: #F27C7C;
  position: absolute;
  top: -20px;
  right: 0;
  font-size: 13px;
  font-weight: 500;
}
.valid,
.invalid {
  &::after {
    position: absolute;
    top: 50%;
    right: -20px;
  }
}
</style>
